import { ELocationPurpose } from '~/data/bookerData'

const groupPrefix = 'locations'

export const apiLocations = {
	fetchLocation: async (locationID: number) => {
		const { data } = await apiCommon<ILocation>(`${groupPrefix}/${locationID}`, { method: 'GET' })
		return LocationFromJSON(data)
	},

	fetchAllLocations: async (page = 1, perPage = 10, type?: string, isActive?: boolean, server?: boolean) => {
		const types = {
			mg: ELocationPurpose.MEET_AND_GREET,
			locations: ELocationPurpose.BRANCH,
		}
		const { data, meta } = await apiCommon<ILocation[]>(`${groupPrefix}`, {
			method: 'GET',
			query: { 'filter[purpose]': type ? types[type] : undefined, 'page[number]': page, 'page[size]': perPage, 'filter[is_active]': isActive },
			server,
		})
		if (!data) return { data: [], meta }
		const response = data.map((product) => {
			return LocationFromJSON(product)
		})
		return { data: response, meta }
	},

	updateLocation: async (locationID: number, locationData: ILocationModel) => {
		const { data } = await apiCommon<ILocation>(`${groupPrefix}/${locationID}`, { method: 'PUT', body: locationToJSON(locationData) })
		return LocationFromJSON(data)
	},

	createLocation: async (locationData: ILocationModel) => {
		const { data } = await apiCommon<ILocation>(`${groupPrefix}`, {
			method: 'POST',
			body: locationToJSON(locationData),
		})
		return LocationFromJSON(data)
	},

	deleteLocation: async (locationID: number) => {
		const data = await apiCommon<string>(`${groupPrefix}/${locationID}`, { method: 'DELETE' })
		return data
	},

	saveLocationsOrder: async (locations: ILocationModel[]) => {
		const data = await apiCommon<ILocationModel[]>(`${groupPrefix}/order`, { method: 'POST', body: { locations } })
		return data
	},

	calculateDeliveryPrice: async (placeID: string, placeType: string) => {
		const type = placeType === EBookerLocationType.START ? 'delivery' : 'collection'
		const { data } = await apiCommon<ILocation>(`${groupPrefix}/nearest?place_id=${placeID}&place_type=${type}`, {
			method: 'GET',
		})
		return data
	},

	fetchAllLocationCities: async (server?: boolean) => {
		const { data } = await apiCommon<ILocationCity[]>(`${groupPrefix}/cities`, {
			method: 'GET',
			server,
		})
		if (!data) return []
		const response = data.map((product) => {
			return LocationCityFromJSON(product)
		})
		return response
	},

	updateLocationsCities: async (locationCities: ILocationCityModel[]) => {
		const data = await apiCommon<ILocationCity[]>(`${groupPrefix}/cities`, {
			method: 'POST',
			body: { locations_cities: locationCities.map((l) => locationCityToJSON(l)) },
		})
		return data
	},
}
